<assessment-row title="Line">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.lineDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" [control]="formGroup().controls.lineIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" [control]="formGroup().controls.lineOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Tube">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.tubeDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.tubeIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.tubeOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Airway">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.airwayDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.airwayIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.airwayOutput" />
      </div>
    </div>
  </div>
</assessment-row>

<assessment-row title="Drain">
  <div class="container">
    <emr-input class="section" type="text" width="65%" placeholder="Description"
      [control]="formGroup().controls.drainDescription" />
    <div class="flex-row">
      <div class="flex-one">
        <span class="intake-output">Intake</span>
        <emr-input type="text" width="30%" title="Intake" [control]="formGroup().controls.drainIntake" />
      </div>
      <div class="flex-one">
        <span class="intake-output width-70">Output</span>
        <emr-input type="text" width="30%" title="Output" [control]="formGroup().controls.drainOutput" />
      </div>
    </div>
  </div>
</assessment-row>